// Single source of truth for ChartInstance ids (config v8+).
//
// Format: `ci_<base36 timestamp>_<6 base36 random chars>`. Doesn't
// need to be globally unique -- just unique within a single saved
// view's `defaultCharts` array. Two callers:
//
//   - `useExplorerConfig.addDefaultChart` (runtime creation)
//   - `migrateConfig` v7 -> v8 (each legacy string catalog id lifted
//     to a ChartInstance gets a fresh id)
//
// Both must produce indistinguishable shapes so migrated and
// runtime-created instances are interchangeable. Keep it here, not
// duplicated, so the format can't drift.

export function makeChartInstanceId () {
  return `ci_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`
}
